import { render, staticRenderFns } from "./DeliveryRules.vue?vue&type=template&id=57abc591&"
import script from "./DeliveryRules.vue?vue&type=script&lang=js&"
export * from "./DeliveryRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports